var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable, makeObservable } from 'mobx';
export class BrowserDragDrop {
    parent;
    get browserRuntime() {
        return this.parent;
    }
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    isDragging = false;
    draggingAction = '';
    draggingObject;
    startDragging(o) {
        this.isDragging = true;
        this.draggingObject = o;
    }
    resetDragDrop() {
        this.isDragging = false;
        this.draggingAction = '';
    }
    onDropBugfix = e => {
        /* 05.04.2019 - needed !!! Bugfix, othervise React onDrop Event ist not firing */
        /* https://stackoverflow.com/questions/50230048/react-ondrop-is-not-firing/50230145 */
        const event = e;
        event.stopPropagation();
        event.preventDefault();
    };
    isDraggingAction(draggingAction) {
        return this.isDragging && this.draggingAction === draggingAction;
    }
}
__decorate([
    observable
], BrowserDragDrop.prototype, "isDragging", void 0);
__decorate([
    observable
], BrowserDragDrop.prototype, "draggingAction", void 0);
__decorate([
    observable.ref
], BrowserDragDrop.prototype, "draggingObject", void 0);
__decorate([
    action.bound
], BrowserDragDrop.prototype, "startDragging", null);
__decorate([
    action.bound
], BrowserDragDrop.prototype, "resetDragDrop", null);
